import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Moment from 'react-moment'

import Button from '../button'
import styles from './header-search-bar.module.scss'
import NativeSelect from '@material-ui/core/NativeSelect'
import { FormControl } from '@material-ui/core'
import WTDatePicker from './date-picker'
import { useTranslation } from 'next-i18next'
import GuestsPopup from '../popups/guests'
import { SearchContext } from '../../lib/context/search-context'
import moment from 'moment'
import config from '../../config'
import { buildQueryString } from '../../lib/helpers'
import { useRouter } from 'next/router'

const HeaderSearchBar = ({
  alt = false,
  guests,
  checkInDate,
  checkOutDate,
  onUpdate,
  showEdit = false,
  onSearch,
  filterTypes,
}) => {
  const checkFilterType = (params) => {
    if (window.location.search.indexOf('filterType') > 0)
      return params.filterType.length === 1 ? params.filterType[0] : null
    return null
  }

  const { t, i18n } = useTranslation()
  const { searchParams, setSearchParameters } = useContext(SearchContext)
  const [params, setParams] = useState(searchParams)
  const [edit, setEdit] = useState(showEdit)
  const [guestsPopup, setGuestsPopup] = useState(false)
  const [numGuests, setNumGuests] = useState(2)
  const [numRooms, setNumRooms] = useState(1)
  const [type, setType] = useState(checkFilterType(searchParams))
  const router = useRouter()

  const handleTypeChange = (event) => {
    if (event.target.value !== 0) {
      const selectedType = filterTypes.filter(
        (filterType) => filterType.id === parseInt(event.target.value)
      )
      setType(selectedType[0])
      setParams(
        { ...params, filterType: selectedType }
      )
    } else {
      setType(null)
      setParams({ ...params, filterType: [] })
    }
  }
  const handleGuestsChange = (value) => {
    setParams({
        ...params,
        guests: value,
      })
    let newGuests = 0
    setNumRooms(value.length)
    value.forEach((guests, i) => {
      newGuests += guests.paxes.length
    })
    setNumGuests(newGuests)
  }
  const updateSearch = (update) => {
    setEdit(update)
  }

  const updateGuests = (value) => {
    setParams({
        ...params,
        guests: value,
      })
    let newGuests = 0
    setNumRooms(value.length)
    value.forEach((guests, i) => {
      newGuests += guests.paxes.length
    })
    setNumGuests(newGuests)
  }

  const handleSearch = () => {
    // console.log(params)
    // setSearchParameters(searchParams, 0, config.cookieOptions)
    window.location.href = `${router.pathname}?${buildQueryString(
      params
    )}`
  }

  useEffect(() => {
    let guests = 0
    searchParams.guests.forEach(({ paxes }, i) => {
      guests += paxes.length
    })
    setNumGuests(guests)
    setNumRooms(searchParams.guests.length)
  }, [searchParams])
  return (
    <React.Fragment>
      {edit && (
        <div
          className={`${styles.headerSearch} ${styles.editSearchBarWrapper}`}
        >
          <div className={styles.editSearchBar}>
            <div className={'showMe'}>
              <FormControl className={styles.select}>
                <NativeSelect
                  value={type ? type.id : 0}
                  onChange={handleTypeChange}
                  inputProps={{
                    name: 'type',
                    id: 'type-select',
                  }}
                  variant={'outlined'}
                >
                  <option value={0}>Everything</option>
                  {filterTypes.map((filterType, i) => (
                    <option key={i} value={filterType.id}>
                      {filterType.name}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
            </div>
            <div className={styles.dates}>
              <WTDatePicker
                hideLabels
                onChange={(dates) => {
                  setParams({
                      ...params,
                      checkinDate: dates.startDate.format('YYYY-MM-DD'),
                      checkoutDate: dates.endDate.format('YYYY-MM-DD'),
                    })
                }}
                defaultStart={
                  !moment.isMoment(searchParams.checkinDate)
                    ? moment(
                        !searchParams.checkinDate
                          ? ''
                          : searchParams.checkinDate
                      )
                    : searchParams.checkinDate
                }
                defaultEnd={
                  !moment.isMoment(searchParams.checkoutDate)
                    ? moment(
                        !searchParams.checkoutDate
                          ? ''
                          : searchParams.checkoutDate
                      )
                    : searchParams.checkoutDate
                }
              />
            </div>
            <div className={styles.guests}>
              <div className={styles.guestsInput}>
                <span
                  onClick={() => {
                    setGuestsPopup(!guestsPopup)
                  }}
                >
                  {numGuests > 0 ? numGuests : 'Add'} Guests, {numRooms} Room
                  {numRooms > 1 && 's'}
                </span>
                {guestsPopup && (
                  <GuestsPopup
                    popupState={setGuestsPopup}
                    guests={searchParams.guests}
                    handleChange={updateGuests}
                  />
                )}
              </div>
            </div>
            <Button
              color={'green'}
              width={'auto'}
              onClick={handleSearch}
              // onClick={() => {
              //
              //   // updateSearch(false)
              //   // onUpdate(params)
              // }}
            >
              <span>Update</span>
            </Button>
          </div>
          <div className={styles.overlay}></div>
        </div>
      )}
      {!edit && (
        <div
          className={`${styles.headerSearch} ${styles.headerSearchBarWrapper}`}
          onClick={() => {
            updateSearch(true)
            if (typeof onSearch != 'undefined') {
              onSearch()
            }
          }}
        >
          <div className={styles.headerSearchBar}>
            <div className={'showMe'}>
              <span>{type ? type.name : 'Everything'}</span>
            </div>
            <div className={styles.dates}>
              <span>
                {moment(searchParams.checkinDate).format('YYYY-MM-DD') ===
                  moment().add(1, 'day').format('YYYY-MM-DD') && (
                  <span>Add Date</span>
                )}
                {moment(searchParams.checkinDate).format('YYYY-MM-DD') !==
                  moment().add(1, 'day').format('YYYY-MM-DD') && (
                  <span>
                    {moment(searchParams.checkinDate).format('D MMM')}
                  </span>
                )}
              </span>
              <hr />
              <span>
                {moment(searchParams.checkoutDate).format('YYYY-MM-DD') ===
                  moment().add(2, 'days').format('YYYY-MM-DD') && (
                  <span>Add Date</span>
                )}
                {moment(searchParams.checkoutDate).format('YYYY-MM-DD') !==
                  moment().add(2, 'days').format('YYYY-MM-DD') && (
                  <span>
                    {moment(searchParams.checkoutDate).format('D MMM')}
                  </span>
                )}
              </span>
            </div>
            <div className={styles.guests}>
              <span>
                {numGuests > 0 ? numGuests : 'Add'} Guests, {numRooms} Room
                {numRooms > 1 && 's'}
              </span>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}
HeaderSearchBar.propTypes = {
  alt: PropTypes.bool,
  guests: PropTypes.array,
  checkInDate: PropTypes.object,
  checkOutDate: PropTypes.object,
  onUpdate: PropTypes.func,
  onSearch: PropTypes.func,
  filterTypes: PropTypes.array,
}
export default HeaderSearchBar
